<div class="mt-4">
  <ol class="breadcrumb bg-white">
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" disabled>Commandes</button></li>
  </ol>
</div>


<div class="my-3 p-3 bg-white rounded shadow-sm">
  <div class="input-group mb-4">
    <div class="input-group-prepend">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
    </div>
    <input type="text" class="form-control" placeholder="Recherche" [(ngModel)]="searchRequest.query" (keyup)="querySearch()"/>

    <supplier-search-criteria class="input-group-append"></supplier-search-criteria>

    <button class="ml-3 btn btn-outline-primary" (click)="openSearchSupplierModal()">Nouvelle commande</button>
  </div>

  <div class="btn-toolbar">
    <div class="input-group pr-2 pb-2" *ngIf="searchRequest.getValues('supplier').length > 0">
      <div class="input-group-prepend">
        <div class="btn btn-secondary btn-sm">{{ displaySupplierFilter() }}</div>
      </div>
      <div class="input-group-append">
        <button class="btn btn-secondary btn-sm" type="button" (click)="clearSupplier()" >X</button>
      </div>
    </div>
  </div>

  <div class="border-bottom"></div>
  
  <search-paging [searchComponent]="this"></search-paging>

  <div *ngIf="results" >
    <div class="container-fluid text-center"*ngFor="let purchaseOrder of results.content">
      <div class="d-flex p-3 mb-3 bg-light rounded shadow-sm row">
        <h5 class="col-xl">{{ purchaseOrder.supplier.name }}</h5>
        <div class="col-xl">Commande {{ purchaseOrder.number }}</div>
        <div class="col-xl">{{ purchaseOrder.references }} référence(s)</div>
        <div class="col-xl p-2">
          <purchase-order-status [status]="purchaseOrder.status"></purchase-order-status>
        </div>
        <div class="col-xl-4">
          <div>Ouverte le <strong>{{ purchaseOrder.creationDate | date: 'medium' }}</strong></div>
          <div *ngIf="purchaseOrder.submitDate">Soumise le <strong>{{ purchaseOrder.submitDate | date: 'medium' }}</strong></div>
          <div *ngIf="purchaseOrder.ackDate">Traité par le fournisseur le <strong>{{ purchaseOrder.ackDate | date: 'medium' }}</strong></div>
          <div *ngIf="purchaseOrder.confirmDate">Confirmée par le fournisseur <strong>{{ purchaseOrder.confirmDate | date: 'medium' }}</strong></div>
          <div *ngIf="purchaseOrder.shippedDate">Expédiée le <strong>{{ purchaseOrder.shippedDate | date: 'medium' }}</strong></div>
          <div *ngIf="purchaseOrder.canceledDate">Annulée le <strong>{{ purchaseOrder.canceledDate | date: 'medium' }}</strong></div>
        </div>
        <div class="col-xl">
          <button class="btn btn-sm btn-outline-primary m-2" (click)="openPurchaseOrder(purchaseOrder)"><span class="bi bi-file-text"></span></button>
        </div>
      </div>
    </div>
  </div>

  <search-paging [searchComponent]="this"></search-paging>
</div>